import { ITeamMember, TeamMemberDto } from "../profile/member.model";

export interface IUser extends ITeamMember {
    old_password?: string;
    new_password?: string;
    signature?:string
}


export class UserDto extends TeamMemberDto implements IUser {
    old_password?: string;
    new_password?: string;
    signature?:string
    constructor(opts?: IUser){
        super(opts)
    }
}


// WEBPACK FOOTER //
// ./src/models/user/user.model.ts